import React, { useEffect, useState } from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import PressReleaseCel from '../PressReleaseCel';
import { getPressList } from '../../../networkCalls';


const PressReleasetab = () => {
    const state = {
        responsive: {
            0: {
                items: 1,
            },
            450: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 4,
            },
        },
    };
    const [loading, setLoading] = useState(false);
    const [resultData, setResultData] = React.useState([]);
    const pullPressrelaseApi = () => {
        var data = new FormData();
        setLoading(true);
        getPressList(data).then((res) => {
            setLoading(false);
            switch (res.data.status) {
                case 1:
                    setResultData(res?.data?.pressList)
                    //setErrMessage('');
                    return true;
                case 0:
                    //setErrMessage(res.data.msz);
                    break;
                default:
                    return;
            }
        })
    }

    useEffect(() => {
        pullPressrelaseApi();
    }, []);

    return (
        <div>
        {loading ? <></> : <>
            {resultData && resultData?.length > 0 ? <>
                <OwlCarousel className='owl-theme with-nav-bottom-center' autoplay={false} items={4} nav={true} dots={false} responsive={state.responsive}>
                    {resultData && resultData?.slice(0, 8)?.map(data =>
                        <div key={data?.dataId} className="p-2">
                            <PressReleaseCel item={data} />
                        </div>
                    )}
                </OwlCarousel>
            </> : <></>}
        </>}
    </div>
    )
}

export default PressReleasetab